module.exports = __webpack_public_path__ + "img/1+.76189d8d.png";